import AdBannersScreen from "@/UI/screens/AdBannersScreen";

export default function AdBannersRoute() {
    return <AdBannersScreen />;
}
